<template>
    <div class="body">
        <p  class="font1" style="padding-top: 13vh;">不积跬步无以至千里，</p>
        <p  class="font1" style="padding-top: 1vh;">不积小流无以成江海。</p>

        <p  class="font2" style="padding-top: 5vh;">推荐书籍如下：</p>

        <div class="wrapper">
            <div class="bookTextOne">
                <h3>《卓有成效的管理者》</h3>
                <div id="qiymet2" @click="openPDF(2)">
                    <p>
                        <i class="fa fa-eye fa-2x"></i>
                    </p>
                </div>
                <p style="padding-bottom: 4px;width: 100%;">作者:彼得·德鲁克</p>
               
            </div>
            <div class="bookTextTwo">
                <h3>《别让猴子跳回背上》</h3>
                <div id="qiymet1" @click="openPDF(1)">
                    <p>
                        <i class="fa fa-eye fa-2x"></i>
                    </p>
                </div>
                <p style="padding-bottom: 4px;width: 100%;">作者：安肯三世</p>  
            </div>
        </div>

        <div class="dialog" v-show="bookShow">        
            <i style="margin-left:95%;color: #090808;" @click="bookShow = false" class="fa fa-close fa-1x"></i>
            <div v-if="this.bookPage==1" style="text-align: justify;width: 100%;">
              <div style="width: 90%;margin: 0 auto;">
                  本书借用猴子譬喻生动形象地讲述了企业组织一旦受困于任务逆转，猴子就会跳回管理者的背上，而不是理应完成任务执行的下属身上。通过职场情景再现的方式提出了如何成为专业管理者的六大规则，浅显易懂，实用有效。<br><br>
                  在职场中，许多管理者都会碰到工作计划执行不下去、组织目标难于实现的问题，搭进了自己所有可以支配的时间，仍旧是焦头烂额，顾此失彼；而下属则因为被授权的层次过低，乐得静候差遣，无事一身轻。<br><br>  
                  最后，管理者、下属，甚至组织的整体工作目标、进度都会停滞不前，造成机械性损耗。<br><br>  
                  为了避免授权失灵、管理不当，管理者应该将注意力放在任务指派、分配与掌控猴子的工作上——主管必须与下属一起协同照顾并且负担起喂养猴子的责任。<br><br>  
                  <p style="font-size: 15px; color: chocolate;">*详情请登录富学宝典上搜索“别让猴子跳回背上”查看！</p>
              </div>
            </div>
            <div v-if="this.bookPage==2" style="text-align: justify;">
              <div style="width: 90%;margin: 0 auto;">
                  《卓有成效的管理者》的基本观念：<br><br>
                  对组织负有责任，能影响组织经营成果的人，就是管理者。<br><br>
                  管理者，就必须卓有成效。<br>
                  卓有成效是可以学会的！<br>
                  如此，一群平凡的人，就做出不平凡的事。<br>
                  书中，德鲁克集中论述了一个管理者如何做到卓有成效。这本书是德鲁克最著名的管理学著作之一，倾注了德鲁克极大的心血。<br>
                  <p style="font-size: 15px; color: chocolate;">*详情请登录富学宝典上搜索“卓有成效的管理者”查看！</p>
              </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
  props: {
    ReportData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      widthWindow: window.innerWidth, 
      widthBlock: window.innerWidth*0.47,
      heightBlock: window.innerHeight*0.257,
      bookPage: 1,
      bookId: 0,
      bookShow: false,
    }
  },
  created() {
    
  },
  methods: {
    openPDF(bookPage) {
      if(bookPage === 1){
        this.bookPage = 1
        this.bookId = 1
      } else {
        this.bookPage = 2
        this.bookId = 2
      }
      this.bookShow = true
    },
  }
}
</script>
  
  <style scoped>
  .body {
      background: url("../../assets/logo.jpg") 15px calc(100% - 20px) no-repeat,
                  url("../../assets/logo1.png") right  top  no-repeat,
                  url("../../assets/24February/bg.jpg")  no-repeat;
      background-size: 17% 8%,117px 50px,cover;
      width: 100%;
      height: 100vh;
      display: flex;
      flex-direction: column;  
      align-items: center;  
  }
  .font1 {
      width: 80%;
      margin: 0;
      /* text-align: center; */
      font-size: 20px;
      color: #fff;
      font-weight: bold;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .font2 { 
      width: 80%;
      margin: 0 auto;
      padding: 0;
      color: #000;
      font-size: 20px;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .font3 {
      font-size: 20px;
      font-weight: bold;
      color: #953b5d;
      text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .dialog {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2000;
      /* bottom: 20%; */
      width: 91%;
      height: auto;
      background: #fff;
      border-radius: 7px;
      padding: 7px;
      box-shadow: #eae62ebd 1px;
  }

  .fa {
      color: #fff8e8;
  }


  .wrapper {
      z-index: 1000;
      width: 97%;
      /* height: auto; */
      height: 35vh;
      display: flex;
      justify-content: center;
      background-color: rgba(255, 255, 255, 0.5);
      border-radius: 10px;;
      border-radius: 17px;
      margin: 0 auto;
      flex-wrap: wrap;
  }

  .bookOne {
      width: 30%;
      height: 20%;
      /* margin-top: 10px; */
  }

  .bookTwo {
      width: 30%;
      height: 20%;
  }

  .bookTextOne {
      margin-left: 11px;
      width: 90%;
      height: 90px;
      color: #000;
  }
  .bookTextTwo {
      margin-left: 11px;
      width: 90%;
      height: 90px;
      color: #000;
    }

    #qiymet2 {
      float: right;
      margin-right: 20px;
      margin-top: -35px;
      padding: 0px 17px 0px 17px;
      border-radius: 20px;
      color: #000;
      font-family: 'Source Code Pro', cursive;
      background-color: rgb(39, 178, 217);
  }

  #qiymet1 {
      float: right;
      margin-right: 20px;
      margin-top: -35px;
      padding: 0px 17px 0px 17px;
      /* width: 51px;
      height: 51px; */
      border-radius: 20px;
      color: #000;
      font-family: 'Source Code Pro', cursive;
      background-color: rgb(39, 178, 217);
      z-index: 1000;
  }

  .zezhao {
      width: 100%;
      height: 100%;
      background: #000000bc;
      z-index: 1920;
      position: absolute;
  }

  button {
      border: none;
      outline: none;
      background-color: rgb(39, 178, 217);
      padding: 10px 20px;
      font-size: 12px;
      font-weight: 700;
      color: #fff;
      border-radius: 5px;
      transition: all ease 0.1s;
      box-shadow: 0px 5px 0px 0px rgb(116, 219, 247);
      margin: 5px;
  }

  button:active {
      transform: translateY(5px);
      box-shadow: 0px 0px 0px 0px rgb(116, 219, 247);
  }

  .donghua{
      animation:flash 3s infinite
    }
    @keyframes flash {
      0% {
        opacity: 0;
      }
      80% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
  }
  </style>